import React from 'react'
import { MetaData } from 'components/MetaData'
import { ProductSelectorHeader } from '../ProductSelectorHeader'
import { ProductSelectorFooter } from '../ProductSelectorFooter'
import { PageWrapper } from './styled'

interface Props {
  children: JSX.Element
  metatitle?: string
  metadescription?: string
  isReviewStep?: boolean
}
export const Layout = ({ children, metatitle, metadescription, isReviewStep = false }: Props) => {
  return (
    <PageWrapper isReviewStep={isReviewStep}>
      <MetaData
        title={metatitle}
        description={metadescription}
      />
      <ProductSelectorHeader />
      {children}
      <ProductSelectorFooter />
    </PageWrapper>
  )
}
